import {
  ADD_MESSAGE_SAVE,
  ADD_MESSAGE_ERROR,
  CLEAR_MESSAGE
} from "../../Constants";

function addUserSuccessMessage(msgs) {
  return {
    type: ADD_MESSAGE_SAVE,
    msgs
  };
}

function addUserErrorMessage(msgs) {
  return {
    type: ADD_MESSAGE_ERROR,
    msgs
  };
}

function clearUserMessage(msgs) {
  return {
    type: CLEAR_MESSAGE,
    msgs
  };
}

export const successMessage = payload => dispatch => {
  dispatch(addUserSuccessMessage(payload));
};

export const errorMessage = payload => dispatch => {
  dispatch(addUserErrorMessage(payload));
};

export const clearMessage = payload => dispatch => {
  dispatch(clearUserMessage(payload));
};